import angular from "angular"
import routing from "./mainmap.routes"
import L from "leaflet"
import moment from "moment"
import { dateAsString, getMomentDateInFuture, getMomentDateInPast, getOrderedMarkerData } from "../shared/utils"

import { MapController } from "../shared/mapcontroller"

let largePitchIcon

// todo need to build out icons with differing sizes for each zoom level? perhaps a whole set per zoom level, would add point events none to highlight circle

function setLargePitchIcon(size = 50) {
  largePitchIcon = L.divIcon({
    className: "pitch-marker-icon my-div-icon leaflet-zoom-hide",
    iconSize: [size, size],
    html: "",
  })
}

export class MainMapController extends MapController {
  minZoom = 0
  layerGroups = {}
  areaAvailablePitches = {}
  flexData = null
  imageLoadError = false

  setupAvailability() {
    this.availabilityStatusShowing = false
    this.setPitchAvailabilityShowing(false)
    this.startDate = undefined
    this.endDate = undefined
    this.availabilityPitchDataSet = false
    if (!this.allUnitsData) {
      this.setAllUnitsData()
    }
    if (!this.availabilityPitchDataSet) {
      this.setAllPhysicalUnitIDS()
    }
  }

  setMarkerAsAvailable(marker) {
    if (
      !this.skipIndividualPitchAvailability && // double check both needed
      !this.$window.flippers.isAvailabilityHidden && // double check both needed
      this.campsitedata.showavailability &&
      this.layerGroups.availableMarkers
    ) {
      if (this.layerGroups.availableMarkers.hasLayer(marker)) {
        marker.options.isAvailable = true
      }
    }
  }

  setAllUnitsData() {
    if (this.campsitedata.booksystemname === "GemaPark") {
      this.$http.get(`/api/availability/GetAllUnits/${this.campsitedata.name}`).then((response) => {
        this.allUnitsData = response.data.data
        if (this.campsitedata.showOccupancyChoices) {
          this.setAllUnitsOccupantsData(response.data.data)
        }
      })
    } else {
      this.allUnitsData = null
    }
  }

  setAllUnitsOccupantsData(unitsData) {
    const unitsString = unitsData.map((unit) => unit.unitID).join()

    this.$http
      .get(`/api/availability/BookingGetOccupantTypes/${this.campsitedata.name}/${unitsString}`)
      .then((response) => response.data.data)
      .then((occupantsData) => {
        this.minMaxOccupantTypesForUnitsData = occupantsData
        this.requiredRequestsLoaded = true
      })
  }

  processAnytimeSubUnits(data) {
    const orderSubUnitData = data.map((unit) => ({
      categoryId: unit.category_id,
      unitId: unit.parent_id,
      name: unit.name,
      physicalUnitId: unit.id,
      description: unit.description,
    }))
    this.availabilityPitchNameData = [...orderSubUnitData]
    this.availabilityPitchNameData.unshift({
      name: "NO PHYSICAL UNIT ID",
      physicalUnitId: undefined,
    })
    this.availabilityPitchDataSet = true
  }

  setAllPhysicalUnitIDS() {
    if (this.campsitedata.booksystemname === "GemaPark") {
      this.$http
        .get(`/api/availability/GetAllPhysicalUnits/${this.campsitedata.name}/${this.campsitedata.gemaparkparkid}`)
        .then((response) => response.data.data)
        .then((allPhysicalUnitsData) => {
          if (this.isManagePage) {
            const previouslyActivePhysicalUnitsData = allPhysicalUnitsData.filter((item) => {
              if (item.endDate) {
                const endDateAsMoment = moment(item.endDate)
                if (moment().isBefore(endDateAsMoment)) {
                  return false
                }
                return true
              }
              return false
            })
            console.log("previously active pages", previouslyActivePhysicalUnitsData)
          }

          const activePhysicalUnitsData = allPhysicalUnitsData.filter((item) => {
            if (item.endDate) {
              const endDateAsMoment = moment(item.endDate)
              return moment().isBefore(endDateAsMoment)
            }
            return true
          })

          this.pitchNameData = activePhysicalUnitsData.map((item) => {
            return {
              unitId: item.unitID,
              name: item.name,
              physicalUnitId: item.physicalUnitID,
              notes: item.notes,
            }
          })

          this.availabilityPitchNameData = getOrderedMarkerData(this.pitchNameData)
          this.availabilityPitchNameData.unshift({
            name: "NO PHYSICAL UNIT ID",
            physicalUnitId: undefined,
          })
          this.availabilityPitchDataSet = true
        })
    }
    if (this.campsitedata.booksystemname === "Anytime") {
      this.$http.get(`/api/availability/GetAllAnytimeUnitDetail/${this.campsitedata.name}/0`).then(
        (unitsRes) => {
          const unitIds = unitsRes.data.map((unit) => unit.id)
          const unitIdsAsString = unitIds.join()
          this.$http
            .get(`/api/availability/GetAllAnytimeUnitDetail/${this.campsitedata.name}/${unitIdsAsString}`)
            .then((unitsRes) => {
              this.processAnytimeSubUnits(unitsRes.data)
            }),
            (reason) => {
              console.error(reason)
            }
        },
        (reason) => {
          console.error(reason)
        }
      )
    }
  }

  setupPolygonDrawingTools() {
    let editableLayers = new L.FeatureGroup()
    this.map.addLayer(editableLayers)

    var drawPluginOptions = {
      position: "topright",
      draw: {
        polygon: {
          allowIntersection: false, // Restricts shapes to simple polygons
          drawError: {
            color: "#e1e100", // Color the shape will turn when intersects
            message: "<strong>Oh snap!<strong> you can't draw that!", // Message that will show when intersect
          },
          shapeOptions: {
            color: "#97009c",
          },
        },
        // disable toolbar item by setting it to false
        polyline: false,
        circle: false, // Turns off this drawing tool
        rectangle: false,
        marker: false,
      },
      edit: {
        featureGroup: editableLayers, //REQUIRED!!
        remove: false,
      },
    }

    var drawControl = new L.Control.Draw(drawPluginOptions)
    this.map.addControl(drawControl)

    editableLayers = new L.FeatureGroup()
    this.map.addLayer(editableLayers)

    this.map.on("draw:created", (e) => {
      const layer = e.layer
      editableLayers.addLayer(layer)
    })
  }

  getDrawPluginOptions(editableLayers) {
    return {
      position: "topright",
      draw: {
        polygon: {
          allowIntersection: false, // Restricts shapes to simple polygons
          drawError: {
            color: "#e1e100", // Color the shape will turn when intersects
            message: "<strong>Oh snap!<strong> you can't draw that!", // Message that will show when intersect
          },
          shapeOptions: {
            color: "#97009c",
          },
        },
        // disable toolbar item by setting it to false
        polyline: false,
        circle: false, // Turns off this drawing tool
        rectangle: false,
        marker: false,
      },
      edit: {
        featureGroup: editableLayers, //REQUIRED!!
        remove: false,
      },
    }
  }

  editMarkerInteractionShape = (markerData) => {
    let editableLayers = new L.FeatureGroup()
    this.map.addLayer(editableLayers)

    var drawControl = new L.Control.Draw(this.getDrawPluginOptions(editableLayers))
    this.map.addControl(drawControl)

    editableLayers = new L.FeatureGroup()
    this.map.addLayer(editableLayers)
    this.addMarkerButtonReady = false
    this.manageFeedback = "Draw the polygon shape"
    this.$mdDialog.hide()

    this.map.on("draw:created", (e) => {
      const layer = e.layer
      editableLayers.addLayer(layer)
      const data = editableLayers.toGeoJSON()
      const currentPolygonShape = data.features[0].geometry.coordinates[0]
      this.manageFeedback = ""
      this.addMarkerButtonReady = true
      // TODO perhaps remove the draw polygon tool at this point by emitting an event to map

      this.map.off("draw:created")
      if (markerData.type === "pitch") {
        this.savePolygonShapeToMarker(currentPolygonShape, markerData._id)
      } else if (markerData.type === "facility") {
        const facilityClone = { ...markerData }
        const facilityIndex = this.getMarkerIndex(markerData.urlstringid, "facilities")
        facilityClone.polygonshape = currentPolygonShape
        this.campsitedata.facilities[facilityIndex] = facilityClone
        this.updateMap("facilities", this.campsitedata.facilities)
      }

      this.$scope.$apply()
    })
  }

  savePolygonShapeToMarker(polygonshape, id) {
    const pitchDataToSave = {
      polygonshape,
      _id: id,
    }

    this.updatePitchMarkers(pitchDataToSave, true)
  }

  loadMap() {
    if (this.campsitedata.backgroundColour) {
      this.backgroundColourStyle = { backgroundColor: this.campsitedata.backgroundColour }
    }
    this.mainmapClasses = `animate-show map ${this.campsitedata.name}`
    this.mapAerialStyle = { ...this.backgroundColourStyle, ...this.sizeMapStyle }
    let aerialWidthBound = this.campsitedata.aerialphotowidth / 4 || 0
    let aerialHeightBound = this.campsitedata.aerialphotoheight / 4 || 0

    let zoomDelta = 1
    this.minZoom = this.campsitedata.minZoomDesktop || 0
    let bounds = [
      [-aerialHeightBound, -aerialWidthBound],
      [aerialHeightBound, aerialWidthBound],
    ]

    const isMobile =
      (this.$window.innerHeight < 768 && this.$window.innerWidth < 1024) ||
      (this.$window.innerWidth < 768 && this.$window.innerHeight < 1024)

    if (isMobile) {
      this.minZoom = this.campsitedata.minZoomMobile || -2
      zoomDelta = 0.5
    }

    const mapImageVersion = this.campsitedata.mapImageVersion ? this.campsitedata.mapImageVersion : ""
    let url = `https://dwf18h5sawogn.cloudfront.net/happycamprassets/campsites/${this.campsitedata.name}${mapImageVersion}.jpg`

    let maxZoom = this.isManagePage ? this.campsitedata.maxzoomback : this.campsitedata.maxzoomfront
    if (!maxZoom) {
      maxZoom = 1
    }

    let mapData = {
      zoomControl: !isMobile,
      crs: L.CRS.Simple,
      url,
      bounds,
      maxBounds: bounds,
      maxZoom,
      minZoom: this.minZoom,
      tapTolerance: 15, // this needs testing
      inertiaDeceleration: 2500,
      inertiaMaxSpeed: 1000,
      center: [0, 0],
      zoom: this.minZoom,
      bounceAtZoomLimits: false,
      zoomDelta,
      tap: true,
      scrollWheelZoom: true,
    }

    this.map = L.map("map-aerial", mapData)
    if (!isMobile) {
      this.map.zoomControl.setPosition("bottomright")
    }
    let imageOverlay = L.imageOverlay(mapData.url, mapData.bounds, { layerid: "aerialimage" }).addTo(this.map)
    imageOverlay.on("load", () => {
      this.appReady = true
      this.imageLoadError = false
      this.$scope.$apply() // needs a scope apply here as is outside angular scope
      this.map.panInsideBounds(this.map.getBounds()) // find this call needed or else doesn't show in correct position after container height set
      this.map.invalidateSize()

      imageOverlay.off("load")
      imageOverlay.off("error")
    })
    imageOverlay.on("error", () => {
      console.warn("Failed to load map image:", mapData.url)
      this.appReady = true
      this.imageLoadError = true
      this.$scope.$apply()
      // Remove the failed image overlay and show a placeholder message
      this.map.removeLayer(imageOverlay)
      imageOverlay.off("load")
      imageOverlay.off("error")
    })
  }

  findPlotIdInIds(plotIds, pitchId) {
    return plotIds.find((plotId) => plotId === pitchId)
  }

  getPitchTypeDataFromPitchId(pitchId) {
    let pitchTypeData
    let pitchTypeSubTypeData
    let foundPlotId
    this.campsitedata.pitchtypes.some((pitchtypeoption) => {
      if (pitchtypeoption.plotIds) {
        foundPlotId = this.findPlotIdInIds(pitchtypeoption.plotIds, pitchId)
        if (foundPlotId) {
          pitchTypeData = pitchtypeoption
          return true
        }
      }
      if (pitchtypeoption.subTypes && pitchtypeoption.subTypes.length) {
        pitchtypeoption.subTypes.some((subTypePitchItem) => {
          if (subTypePitchItem.plotIds) {
            foundPlotId = this.findPlotIdInIds(subTypePitchItem.plotIds, pitchId)
            if (foundPlotId) {
              pitchTypeData = pitchtypeoption
              pitchTypeSubTypeData = subTypePitchItem
              return true
            }
            return null
          }
          return null
        })
        if (foundPlotId) {
          return true
        }
      }
      return null
    })
    return {
      pitchTypeData,
      pitchTypeSubTypeData,
    }
  }

  deselectAvailabiltyPitch() {
    if (this.skipIndividualPitchAvailability) {
      this.deselectSelectedMarkerAndSetIcon(this.getLargeBlankIcon())
      return true
    }

    if (this.filteredPitchTypeNames?.length) {
      let foundItem = false
      this.filteredPitchTypeNames.forEach((name) => {
        if (!foundItem) {
          const pitchTypeLayer = this.pitchTypeLayers[name]
          if (pitchTypeLayer && pitchTypeLayer.hasLayer(this.selectedMarker)) {
            foundItem = true
            this.deselectSelectedMarkerAndSetIcon(this.getIcon("available-icon"))
            return true
          }
        }
      })
      if (!foundItem) {
        this.deselectSelectedMarkerAndSetIcon(this.getLargeBlankIcon())
      }
      return true
    }

    if (this.layerGroups?.availableMarkers?.hasLayer(this.selectedMarker)) {
      this.deselectSelectedMarkerAndSetIcon(this.getIcon("available-icon"))
      return true
    }
  }

  addTransitions() {
    this.deregisterTransitionListener2 = this.$transitions.onSuccess({ entering: "mainmap.home" }, () => {
      if (this.selectedMarker) {
        this.deHighlightSelectedMarker()
      }
    })
  }

  getLargeBlankIcon() {
    return largePitchIcon
  }

  addMarkers() {
    setLargePitchIcon(this.campsitedata.pitchmarkersize)

    let types = [
      {
        type: "pitch",
        data: this.campsitedata.markers,
      },
      {
        type: "facility",
        data: this.campsitedata.facilities,
      },
    ]

    this.addAllMarkerTypes(types)

    if (!this.campsitedata.isarealabelsdisabled) {
      this.addAreaNames()
    }

    this.addMarkerButtonReady = true

    if (this.campsitedata.showavailability && !this.$window.flippers.isAvailabilityHidden) {
      this.setupAvailability()
      this.addAvailabilityMarkers()
      // todo here need to add a special additional marker if area is grouped.
      // This will alsways be green if any physical pitches in that group are available.
    }

    // add highlights
    if (this.campsitedata.showHighlights) {
      this.layerGroups.forSaleHighlights = new L.layerGroup()
      this.map.addLayer(this.layerGroups.forSaleHighlights)
      this.layerGroups.rentalHighlights = new L.layerGroup()
      this.map.addLayer(this.layerGroups.rentalHighlights)

      this.layerGroups.allMarkers.getLayers().forEach((marker) => {
        if (marker.options.type === "pitch") {
          // console.log(marker)
          if (marker.options.highlightType === "rentals") {
            this.layerGroups.rentalHighlights.addLayer(marker)
          } else if (marker.options.highlightType === "sales") {
            this.layerGroups.forSaleHighlights.addLayer(marker)
          }
        }
      })
    }
  }

  toggleAvailabilityStatusMinimized() {
    this.availabilityStatusMinimized = !this.availabilityStatusMinimized
    //this.setMainMapSize()
  }

  addAreaNames() {
    for (let a = 0; a < this.campsitedata.areaoptions.length; a++) {
      let areaoption = this.campsitedata.areaoptions[a]

      if (areaoption.centerlat) {
        // currently facilities area option has no centerlat/lng -- weird - must fix?
        let areaIcon = new L.divIcon({
          className: "my-div-icon leaflet-zoom-hide area-marker",
          iconSize: [200, 50],
          html: `<div class="area-name">${areaoption.name}</div>`,
        })

        let opts = {}
        opts.icon = areaIcon
        opts.name = areaoption.name
        opts.urlstringid = areaoption.urlstringid
        opts.type = "area"
        opts.zIndexOffset = 3000
        const areaLatLng = [areaoption.centerlat, areaoption.centerlng]

        let areamarker = L.marker(areaLatLng, opts)

        if (this.isManagePage) {
          this.handleManageMarkerClick(areamarker)
        }

        this.layerGroups.allMarkers.addLayer(areamarker)
      }
    }
  }

  setEditingAvailability(value) {
    this.editingAvailability = value
  }

  doScopeApply = () => {
    if (!this.$scope.$$phase) {
      this.$scope.$apply()
    }
  }

  editAvailability() {
    this.setAvailabilityStatusShowing(false)
    this.setAvailabilityCheckShowing(true)
    this.setEditingAvailability(true)

    this.doScopeApply()
  }

  resetAvailabilityFromStatus() {
    this.setEditingAvailability(false)
    this.setAvailabilityStatusShowing(false)
    if (!this.skipIndividualPitchAvailability) {
      this.resetMarkerAvailabilities()
    }
    this.map.flyTo([0, 0], this.minZoom)
    this.$state.go("mainmap.home") // this won't always trigger a redirection so need to make sure that it does for main map resize
  }

  setPitchAvailabilityShowing(value) {
    this.pitchAvailabilityShowing = value
  }

  bookGemaParkByPitch() {
    this.setPitchAvailabilityShowing(true)
  }

  setAvailabilityStatusShowing(value) {
    this.availabilityStatusShowing = value
  }

  setAvailabilityCheckShowing(value) {
    this.availabilityCheckShowing = value
  }

  handleCloseAvailabilityCheck() {
    if (this.editingAvailability) {
      this.setAvailabilityStatusShowing(true)
      this.setAvailabilityCheckShowing(false)
    } else {
      this.setAvailabilityCheckShowing(false)
      this.setAvailabilityStatusShowing(false)
    }
    // current there is an error, but wont' be when this is triggered from react component
    this.doScopeApply()
  }

  setAvailabilityTransitionFalse() {
    this.availabilityTransition = false
  }

  loadAvailCheckRoute = (e) => {
    const { categoryId, unitId, startDate, endDate, numOfAdults, numOfChildren, numOfInfants, stayTypeId } = e // not sure unitId is ever used present or not null? don't see it being applied anywhere
    const occupancyData = this.campsitedata.showOccupancyChoices
      ? {
          numofadults: numOfAdults === "" ? 0 : numOfAdults,
          numofchildren: numOfChildren === "" ? 0 : numOfChildren,
          numofinfants: numOfInfants === "" ? 0 : numOfInfants,
        }
      : {}

    // staytypeid disambiguates when GemaPark returns multiple stayTypes under
    // the same categoryID (e.g. {1: Self Catering, 1: Glamping, 2: Touring}).
    // Optional so legacy URLs (no staytypeid segment) still resolve to the
    // first match for their categoryID.
    const stayTypeIdForUrl = stayTypeId === null || stayTypeId === undefined || Number.isNaN(stayTypeId) ? "null" : stayTypeId

    let result = {
      categorytype: categoryId === null || Number.isNaN(categoryId) ? "null" : categoryId,
      accomtype: unitId === null || Number.isNaN(unitId) ? "null" : unitId,
      startdate: dateAsString(startDate),
      enddate: dateAsString(endDate),
      staytypeid: stayTypeIdForUrl,
      ...occupancyData,
    }
    if (this.campsitedata.showOccupancyChoices) {
      this.$state.go("mainmap.home.availability-with-occupancy", result)
    } else {
      this.$state.go("mainmap.home.availability", result)
    }
  }

  setAvailParamsInRootForStateChange = (event) => {
    this.currentAvailSearchParams = event
  }

  handleClickGoPast = () => {
    const endDateAsMoment = this.currentAvailSearchParams.endDate
    const endDateMinusOneDay = getMomentDateInPast(endDateAsMoment, 1)

    const startDateAsMoment = this.currentAvailSearchParams.startDate
    const startDateMinusOneDay = getMomentDateInPast(startDateAsMoment, 1)

    this.loadAvailCheckRoute({
      ...this.currentAvailSearchParams,
      endDate: endDateMinusOneDay,
      startDate: startDateMinusOneDay,
    })
  }

  handleClickGoFuture = () => {
    const startDateAsMoment = this.currentAvailSearchParams.startDate
    const startDatePlusOneDay = getMomentDateInFuture(startDateAsMoment, 1)

    const endDateAsMoment = this.currentAvailSearchParams.endDate
    const endDatePlusOneDay = getMomentDateInFuture(endDateAsMoment, 1)

    this.loadAvailCheckRoute({
      ...this.currentAvailSearchParams,
      endDate: endDatePlusOneDay,
      startDate: startDatePlusOneDay,
    })
  }

  updateFlexibilityData(e) {
    this.flexData = e.flexData
    this.doScopeApply()
  }

  updateChosenAvailabilityDates(e) {
    this.startDate = e.startDate
    this.endDate = e.endDate
    this.unitsData = e.unitsData
    this.accomodationType = e.accomodationType
    this.numOfAdults = e.numOfAdults
    this.numOfChildren = e.numOfChildren
    this.numOfInfants = e.numOfInfants
    // in future unit and category id can just be set when picking the item of from availability check dropdown
    this.accomodationUnitId = e.accomodationUnitId || null
    // this should be categoryIndex? not Id?
    this.categoryId = e.categoryId || null
    if (e.allAvailableAnytimeData?.subUnitsArray && e.allAvailableAnytimeData.subUnitsArray.length) {
      this.allAvailableAnytimeData = e.allAvailableAnytimeData
    }
    this.isPitchBookingLimited = e.isPitchBookingLimited
    this.skipIndividualPitchAvailability = e.skipIndividualPitchAvailability || e.isPitchBookingLimited

    this.availabilityTransition = false
    this.unitIdsForPhysicalUnitIds = e.unitIdsForPhysicalUnitIds

    this.showAvailablePitches(e.availablePhysicalUnitNumbers)
    this.$state.go("mainmap.home.availability-status")
  }

  handleAvailabilityButtonClick() {
    this.setAvailabilityStatusShowing(false)
    this.setAvailabilityCheckShowing(true)
  }

  addAvailabilityMarkers() {
    this.layerGroups.availableMarkers = new L.layerGroup()
    this.map.addLayer(this.layerGroups.availableMarkers)
  }

  resetAvailability() {
    this.map.flyTo([0, 0], this.minZoom)
    this.$state.go("mainmap.home")
    this.availabilityTransition = false
  }

  resetFlexData = () => {
    this.flexData = null
  }

  resetMarkerAvailabilities() {
    this.areaAvailablePitches = {}
    this.layerGroups.allMarkers.eachLayer((layer) => {
      if (layer.options.type === "pitch") {
        layer.options.isAvailable = undefined
        layer.setIcon(this.getLargeBlankIcon())
      }
    })

    if (this.selectedMarker) {
      this.selectedMarker.setIcon(this.getDivIcon("pitch", null, true))
    }

    this.layerGroups.availableMarkers.clearLayers()
    this.availableMarkersShowing = false

    if (this.campsitedata.showFlexibleDates) {
      this.resetFlexData()
    }
    // this.map.fire('moveend'); // ensures the current selected marker icon is still showing
  }

  availabilityStatusMinimized = false

  getIcon(iconClass) {
    // todo size of this marker should also be dynamically loaded set on campsite
    return L.divIcon({
      className: "my-div-icon leaflet-zoom-hide",
      iconSize: [this.campsitedata.pitchmarkersize, this.campsitedata.pitchmarkersize],
      html: `<div class="${iconClass}"></div>`,
    })
  }

  showAvailablePitches(availablePhysicalUnitNumbers) {
    this.layerGroups.availableMarkers.clearLayers()
    this.pitchTypeFilterValue = null
    this.map.flyTo([0, 0], this.minZoom)

    if (availablePhysicalUnitNumbers) {
      this.layerGroups.allMarkers.eachLayer((layer) => {
        if (layer.options.type === "pitch" && layer.options.physicalunitids) {
          if (
            layer.options.physicalunitids.length === 1 &&
            availablePhysicalUnitNumbers.indexOf(layer.options.physicalunitids[0]) !== -1
          ) {
            if (!this.skipIndividualPitchAvailability) {
              layer.options.isAvailable = true
              layer.setIcon(this.getIcon("available-icon"))
            }
            this.layerGroups.availableMarkers.addLayer(layer)
          } else if (layer.options.physicalunitids.length > 1) {
            for (let c = 0; c < layer.options.physicalunitids.length; c++) {
              if (availablePhysicalUnitNumbers.indexOf(layer.options.physicalunitids[c]) !== -1) {
                if (this.areaAvailablePitches[layer.options.name]) {
                  this.areaAvailablePitches[layer.options.name] = this.areaAvailablePitches[layer.options.name] + 1
                } else {
                  this.areaAvailablePitches[layer.options.name] = 1
                }
                if (!this.skipIndividualPitchAvailability) {
                  layer.setIcon(this.getIcon("available-icon"))
                  layer.options.isAvailable = true
                }
                this.layerGroups.availableMarkers.addLayer(layer)
              }
            }
          } else {
            if (!this.skipIndividualPitchAvailability) {
              layer.options.isAvailable = false
            }
          }
        }
      })
      const availablePitchTypes = []
      this.pitchTypeLayers = {}
      let numOfAvailableMarkersByType = {}
      const availableMarkerLayers = this.layerGroups.availableMarkers.getLayers()

      availableMarkerLayers.forEach((markerLayer) => {
        if (this.campsitedata.booksystemname === "GemaPark") {
          if (markerLayer.options.isMultiPhysicalUnits) {
            const pitchTypeName = markerLayer.options.area
            availablePitchTypes.push({
              name: pitchTypeName,
              pricingData: this.unitsData.find((unit) => unit.unitID === markerLayer.options.unitid)?.pricing, // need to fix
              unitId: markerLayer.options?.unitid,
            })
            numOfAvailableMarkersByType[pitchTypeName] = markerLayer.options.physicalunitids.length
            this.pitchTypeLayers[pitchTypeName] = L.layerGroup([markerLayer])
          } else {
            const unit = this.getGemaParkUnitFromMarkerLayer(markerLayer)[0]
            const pitchTypeName = unit?.name
            const hasPitchTypeDataSet = availablePitchTypes.find((pitchType) => pitchType.name === pitchTypeName)

            if (!hasPitchTypeDataSet) {
              availablePitchTypes.push({
                name: pitchTypeName,
                pricingData: unit?.pricing,
                unitId: unit?.unitID,
              })
              numOfAvailableMarkersByType[pitchTypeName] = 1
              this.pitchTypeLayers[pitchTypeName] = L.layerGroup([markerLayer])
            } else {
              numOfAvailableMarkersByType[pitchTypeName] = numOfAvailableMarkersByType[pitchTypeName] + 1
              this.pitchTypeLayers[pitchTypeName].addLayer(markerLayer)
            }
          }
        }

        if (this.campsitedata.booksystemname === "Anytime") {
          const pitchTypeName = this.getPitchTypeNameFromMarkerData(markerLayer)
          const hasPitchTypeDataSet = availablePitchTypes.find((pitchType) => pitchType.name === pitchTypeName)

          if (!hasPitchTypeDataSet) {
            // getting the 0 index here might not work for sites like gateway, but that is gemapark, need to check
            const markerData = this.getMarkerDataByPhysicalId(markerLayer.options.physicalunitids[0])
            const unitId = markerData?.unitId
            const categoryId = markerData?.categoryId
            availablePitchTypes.push({ name: pitchTypeName, unitId, categoryId })
            numOfAvailableMarkersByType[pitchTypeName] = 1
            this.pitchTypeLayers[pitchTypeName] = L.layerGroup([markerLayer])
          } else {
            numOfAvailableMarkersByType[pitchTypeName] = numOfAvailableMarkersByType[pitchTypeName] + 1
            this.pitchTypeLayers[pitchTypeName].addLayer(markerLayer)
          }
        }
      })
      this.numOfAvailableMarkersByType = numOfAvailableMarkersByType

      this.availablePitchTypeOptions = availablePitchTypes
      this.availableMarkersShowing = true

      // zoom to available markers
      // all layers stored in availableMarkerLayers

      // if (availableMarkerLayers.length) {
      //   const latLngsArray = []
      //   availableMarkerLayers.forEach((markerLayer) => {
      //     const latLng = markerLayer.getLatLng()
      //     latLngsArray.push([latLng.lat, latLng.lng])
      //   })

      //   this.map.flyToBounds(latLngsArray)
      // }
    } else {
      console.error("availability data error")
    }
  }

  getMarkerDataByPhysicalId(physicalUnitId) {
    if (this.availabilityPitchNameData) {
      const item = this.availabilityPitchNameData.find((item) => item.physicalUnitId === physicalUnitId)
      return item
    }
    return null
  }

  getPitchTypeNameFromMarkerData(markerLayer) {
    const markerData = markerLayer.options
    if (markerData.pitchTypeSubTypeData && markerData.pitchTypeSubTypeData.type) {
      return markerData.pitchTypeSubTypeData.type
    }

    if (markerData.pitchTypeData && markerData.pitchTypeData.type) {
      return markerData.pitchTypeData.type
    }
  }

  getGemaParkUnitFromMarkerLayer(markerLayer) {
    const markerData = markerLayer.options
    const unitId = this.unitIdsForPhysicalUnitIds[markerData.physicalunitids[0]]
    return this.unitsData.filter((unit) => unit.unitID === unitId)
  }

  handlePickPitchButton() {
    // should trigger a post message here sending the selected pitch name/id
    // const targetOrigin = this.campsitedata.booksystemname === "Anytime" ? "anytime address" : "gemapark addressd");
    window.parent.postMessage(this.selectedMarker.options.physicalunitids[0], "*")
  }

  // should be moved into its own angular component
  handleMarkerSelectorChange = (markerIndex) => {
    if (markerIndex === null) {
      if (this.availableMarkersShowing) {
        this.$state.go("mainmap.home.availability-status")
      } else {
        this.$state.go("mainmap.home")
      }
    } else {
      const selectedMarker = this.campsiteMarkers[markerIndex]
      this.$state.go("mainmap.markers.detail", {
        mapid: this.$transition$.params().mapid,
        markers: selectedMarker?.type === "pitch" ? "pitch" : "facility",
        name: selectedMarker.urlstringid,
      })
    }
  }

  checkIfAllOptionsSame = (checkedState, status) =>
    checkedState.e.filter((item) => item === status).length === this.availablePitchTypeOptions.length

  handleFilterAvailabilePitches(checkedState) {
    if (!this.skipIndividualPitchAvailability) {
      // anytime booking specific
      const allChecked = this.checkIfAllOptionsSame(checkedState, "checked")
      const allNotChecked = this.checkIfAllOptionsSame(checkedState, "unchecked")
      this.filteredPitchTypeNames = []

      // const latLngsForBounds = []
      if (allChecked || allNotChecked) {
        this.layerGroups.availableMarkers.getLayers().forEach((markerLayer) => {
          markerLayer.setIcon(this.getIcon("available-icon"))
          // const latLng = markerLayer.getLatLng()
          // latLngsForBounds.push([latLng.lat, latLng.lng])
        })
      } else {
        checkedState.e.forEach((check, index) => {
          const filteredPitchTypeName = this.availablePitchTypeOptions[index].name
          if (check === "checked") {
            this.pitchTypeLayers[filteredPitchTypeName].getLayers().forEach((markerLayer) => {
              markerLayer.setIcon(this.getIcon("available-icon"))
              //    const latLng = markerLayer.getLatLng()
              //   latLngsForBounds.push([latLng.lat, latLng.lng])
            })
            this.filteredPitchTypeNames.push(filteredPitchTypeName)
          }
          if (check === "unchecked") {
            this.pitchTypeLayers[filteredPitchTypeName].getLayers().forEach((markerLayer) => {
              markerLayer.setIcon(this.getLargeBlankIcon())
            })
          }
        })
      }
      // this.map.flyToBounds(latLngsForBounds)
    }
  }

  handleClickHighlight = (type, isActive) => {
    console.log("handleClickHighlight", type, isActive)

    // Initialize highlight states if not already done
    if (!this.highlightStates) {
      this.highlightStates = {
        rentals: false,
        sales: false,
      }
    }

    // Update the state for this highlight type
    this.highlightStates[type] = isActive

    // Handle rentals highlighting
    if (type === "rentals") {
      this.layerGroups.rentalHighlights.getLayers().forEach((markerLayer) => {
        if (isActive) {
          markerLayer.options.previousIcon = markerLayer.options.icon
          markerLayer.setIcon(this.getIcon("highlight-ring-icon-rentals"))
        } else {
          // Restore to blank icon or keep sales highlight if sales is active
          if (this.highlightStates.sales && this.layerGroups.forSaleHighlights.hasLayer(markerLayer)) {
            markerLayer.setIcon(this.getIcon("highlight-ring-icon-sales"))
          } else {
            markerLayer.setIcon(this.getLargeBlankIcon())
          }
        }
      })
    }

    // Handle sales highlighting
    if (type === "sales") {
      this.layerGroups.forSaleHighlights.getLayers().forEach((markerLayer) => {
        if (isActive) {
          markerLayer.options.previousIcon = markerLayer.options.icon
          markerLayer.setIcon(this.getIcon("highlight-ring-icon-sales"))
        } else {
          // Restore to blank icon or keep rentals highlight if rentals is active
          if (this.highlightStates.rentals && this.layerGroups.rentalHighlights.hasLayer(markerLayer)) {
            markerLayer.setIcon(this.getIcon("highlight-ring-icon-rentals"))
          } else {
            markerLayer.setIcon(this.getLargeBlankIcon())
          }
        }
      })
    }

    console.log(this.selectedMarker)
  }
}

export default angular
  .module("makeamapAngularApp.mainmap", ["makeamapAngularApp.auth", "ui.router"])
  .config(routing)
  .component("mainmap", {
    bindings: {
      campsitedata: "<",
      $transition$: "<",
    },
    template: require("./mainmap.html"),
    controller: MainMapController,
    transclude: false,
  }).name
